import { useEffect } from 'react';

/** Used as a workaround for incorrect scroll position after navigation/refresh, when certain components have dynamic height.  */
export function useScrollRestoration(restoration: ScrollRestoration) {
	useEffect(() => {
		if (history.scrollRestoration) {
			history.scrollRestoration = restoration;
		}
	}, []);
}
